(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["comprehensive-menu"] && !Shopify.designMode) return;
  try {
    class ComprehensiveMenu extends HTMLElement {
    constructor() {
      super();
      this.setupMenuInteractions();
    }

    setupMenuInteractions() {
      const menuItems = this.querySelectorAll('.comprehensive-menu__item--has-dropdown');
      
      menuItems.forEach(item => {
        const button = item.querySelector('.comprehensive-menu__link--parent');
        const dropdown = item.querySelector('.comprehensive-menu__dropdown');
        
        if (!button || !dropdown) return;

        // Toggle on click
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          
          // Close all other dropdowns
          this.closeAllDropdowns();
          
          if (!isExpanded) {
            button.setAttribute('aria-expanded', 'true');
            dropdown.removeAttribute('hidden');
          }
        });

        // Close on outside click
        document.addEventListener('click', (e) => {
          if (!item.contains(e.target)) {
            this.closeDropdown(button, dropdown);
          }
        });

        // Keyboard navigation
        button.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeDropdown(button, dropdown);
            button.focus();
          }
        });
      });
    }

    closeDropdown(button, dropdown) {
      button.setAttribute('aria-expanded', 'false');
      dropdown.setAttribute('hidden', '');
    }

    closeAllDropdowns() {
      const allButtons = this.querySelectorAll('.comprehensive-menu__link--parent');
      const allDropdowns = this.querySelectorAll('.comprehensive-menu__dropdown');
      
      allButtons.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
      allDropdowns.forEach(dd => dd.setAttribute('hidden', ''));
    }
  }

  customElements.define('comprehensive-menu', ComprehensiveMenu);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image"] && !Shopify.designMode) return;
  try {
    // Add loaded class when image loads
  document.addEventListener('DOMContentLoaded', () => {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    
    lazyImages.forEach(img => {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', () => {
          img.classList.add('loaded');
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    class SearchModal {
    constructor() {
      this.modal = document.querySelector('[data-search-modal]');
      this.input = document.querySelector('[data-search-input]');
      this.results = document.querySelector('[data-search-results]');
      this.toggleBtn = document.querySelector('[data-search-toggle]');
      this.closeElements = document.querySelectorAll('[data-search-close]');
      
      this.init();
    }

    init() {
      // Open modal
      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', () => this.open());
      }

      // Close modal
      this.closeElements.forEach(el => {
        el.addEventListener('click', () => this.close());
      });

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
          this.close();
        }
      });

      // Search input
      if (this.input) {
        this.input.addEventListener('input', (e) => {
          this.handleSearch(e.target.value);
        });
      }
    }

    open() {
      this.modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      setTimeout(() => {
        if (this.input) this.input.focus();
      }, 300);
    }

    close() {
      this.modal.classList.remove('is-active');
      document.body.style.overflow = '';
      if (this.input) this.input.value = '';
    }

    async handleSearch(query) {
      if (query.length < 2) return;

      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`
        );
        const data = await response.json();
        this.renderResults(data.resources.results.products);
      } catch (error) {
        console.error('Search error:', error);
      }
    }

    renderResults(products) {
      if (!products || products.length === 0) {
        this.results.innerHTML = '<p class="search-modal__no-results">No products found</p>';
        return;
      }

      const html = `
        <div class="search-modal__products">
          ${products.map(product => `
            <a href="${product.url}" class="search-modal__product">
              ${product.featured_image ? `
                <img 
                  src="${product.featured_image}" 
                  alt="${product.title}"
                  width="60"
                  height="60"
                >
              ` : ''}
              <div class="search-modal__product-info">
                <h4>${product.title}</h4>
                <p>${Shopify.formatMoney(product.price, theme.moneyFormat)}</p>
              </div>
            </a>
          `).join('')}
        </div>
      `;

      this.results.innerHTML = html;
    }
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new SearchModal());
  } else {
    new SearchModal();
  }
  } catch(e) { console.error(e); }
})();

})();
